import { create } from 'zustand';
import { IUserData } from '../types/orders';

interface IUserDataAccount extends IUserData {
  calendarLink: string;
  phoneNumber: string;
}

interface IStateAccount {
  firstDataLoad: boolean;
  userStateData: IUserDataAccount;
  setFirstDataLoad: (firstDataLoad: boolean) => void;
  setUserStateData: (userData: Partial<IUserDataAccount>) => void;
}

const useAccountState = create<IStateAccount>(set => ({
  firstDataLoad: false,
  userStateData: {
    profilePhoto: '',
    firstName: '',
    lastName: '',
    calendarLink: '',
    phoneNumber: ''
  },
  setFirstDataLoad: firstDataLoad => set({ firstDataLoad }),
  setUserStateData: newUserData =>
    set(state => ({
      userStateData: {
        ...state.userStateData,
        ...newUserData
      }
    }))
}));

export default useAccountState;
